import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

const app = createApp(App);

// Common Services
import backendDialog from "./services/backendDialog";
import services from "./services/services";
app.config.globalProperties.$backendDialog = backendDialog;
app.config.globalProperties.$services = services;

// Common Componants
import commonComponents from "./components/common";
commonComponents.forEach((component) => {
  app.component(component.name, component);
});

app.use(router);
app.use(store);
app.mount("#app");
